(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function lockDecorativeVideos(root) {
    var scope = root || document;
    var blockers = scope.querySelectorAll('.video-interaction-blocker');

    blockers.forEach(function (blocker) {
      var container = blocker.parentElement;
      var video = container && container.querySelector('video');
      if (!video) return;

      video.controls = false;
      video.removeAttribute('controls');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', 'true');
      video.setAttribute('controlslist', 'nodownload noremoteplayback nofullscreen');
      video.setAttribute('x-webkit-airplay', 'deny');

      try {
        video.disablePictureInPicture = true;
      } catch (error) {}
    });
  }

  lockDecorativeVideos();

  document.addEventListener('shopify:section:load', function (event) {
    lockDecorativeVideos(event.target);
  });

  var videoControlsObserver = new MutationObserver(function () {
    lockDecorativeVideos();
  });

  videoControlsObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['controls'],
  });
  } catch(e) { console.error(e); }
})();

})();
